import styled from 'styled-components';
import { color, space, font, query } from '@design/templateFns';

import { Swiper, SwiperSlide } from 'swiper/react';

export const VideoGallerySwiperWrapper = styled.div`
  padding-bottom: 3px; // so the Block component does't cut off the red underline

  //removing some default swiper styles
  .swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet,
  .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0;
  }
  .swiper-pagination-bullet {
    height: auto;
    opacity: 1;
    border-radius: 0;
  }
  .swiper-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    z-index: 1;
    display: flex;
    transition-property: transform;
    box-sizing: content-box;
  }

  .swiper-slide {
    margin-top: 0;
  }

  .swiper-android .swiper-slide,
  .swiper-wrapper {
    transform: translate3d(0px, 0, 0);
  }
  .swiper-pointer-events {
    touch-action: pan-y;
    &.swiper-vertical {
      touch-action: pan-x;
    }
  }
  .swiper-slide-invisible-blank {
    visibility: hidden;
  }
`;

export const VideoGalleryHeadline = styled.h2`
  ${font('headline-md')};
  text-align: center;
  padding-bottom: 0;

  @media screen and (${query.below('tablet')}) {
    ${font('headline-xs')};
  }
`;

export const VideoGallerySwiper = styled(Swiper)`
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  overflow: hidden;
  list-style: none;
  padding: 0;
  /* Fix of Webkit flickering */
  z-index: 1;
`;

export const VideoGallerySwiperSlide = styled(SwiperSlide)`
  flex-shrink: 0;
  position: relative;
  transition-property: transform;
  display: flex;
  align-items: stretch;
  margin-top: ${space('xl')};
`;

export const VideoGallerySwiperButtonWrapper = styled.div`
  display: flex;
  align-items: stretch;
  border-width: 0 0 1px 0;
  border-style: solid;
  border-color: ${color('gray2')};
  overflow: visible;
  margin-top: ${space('xl')};

  @media screen and (${query.below('desktop')}) {
    align-items: center;
    flex-direction: column;
    border-width: 0;
    margin-top: 0;
  }

  button {
    //remove default button styles
    background: none;
    padding: ${space('md')} ${space('lg')};
    margin: 0;
    cursor: pointer;
    outline: none;
    border: none;
    overflow: visible;
    width: 100%;
    flex: 1 0 0%;
    position: relative;

    @media screen and (${query.atLeast('desktop')}) {
      //instead of using gap for underline to render properly
      //remove left padding on first button
      &:first-child {
        padding-left: 0;
      }
      //remove right padding on last button
      &:last-child {
        padding-right: 0;
      }

      padding: ${space('md')} ${space('md')};
    }

    @media screen and (${query.below('desktop')}) {
      border-bottom: 1px solid ${color('gray2')};

      &:hover {
        background-color: ${color('gray1')};
      }
    }

    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 3px;
      background: transparent;
      position: absolute;
      left: 0;
      bottom: -2px;
      transition: background 0.3s ease;

      @media screen and (${query.below('desktop')}) {
        width: 3px;
        height: 100%;
        bottom: auto;
        top: 0;
        left: 0;
      }
    }

    &:hover::after {
      background: ${color('gray2')};
    }

    &.swiper-pagination-bullet-active {
      @media screen and (${query.below('desktop')}) {
        background-color: ${color('gray1')};
      }

      &::after {
        background: ${color('cta')};
      }
    }
  }
`;
